require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-toorak-garden-residence-featured-in-mansion-magazine.json") })
        }
      }, "path---journal-toorak-garden-residence-featured-in-mansion-magazine");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-toorak-garden-residence-featured-in-mansion-magazine!./.cache/json/journal-toorak-garden-residence-featured-in-mansion-magazine.json
// module id = 547
// module chunks = 231608221292675